import { render, staticRenderFns } from "./CollectionAdd.vue?vue&type=template&id=42ca69b4&scoped=true"
import script from "./CollectionAdd.vue?vue&type=script&lang=js"
export * from "./CollectionAdd.vue?vue&type=script&lang=js"
import style0 from "./CollectionAdd.vue?vue&type=style&index=0&id=42ca69b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ca69b4",
  null
  
)

export default component.exports